import { Text } from '@change/ds-core-ui';

import type { SavedPaymentMethodOption } from '../../shared/types';

type Props = {
	selectedPaymentMethod: SavedPaymentMethodOption | null;
	onSelectPaymentMethod: (paymentMethod: string) => void;
};

export const SelectNewCardButton: React.FC<Props> = ({ selectedPaymentMethod, onSelectPaymentMethod }) => {
	if (selectedPaymentMethod === 'new') {
		return null;
	}

	return (
		<Text
			className="cursor-pointer pt-2 pb-3 underline"
			data-qa="add-new-payment-method"
			tabIndex={0}
			role="button"
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					onSelectPaymentMethod('new');
				}
			}}
			onClick={() => onSelectPaymentMethod('new')}
		>
			{/* TODO: translate when productized */}+ Add new card
		</Text>
	);
};
